import { apiGet } from '@forwardflow/services/Axios/configs'
import {
   IAnalyticsStats,
   IFubLostOpportunities,
   IIncompleteInformation,
   IStageData,
   ITimeTakenForFirstCall,
   ResponseSuccess,
} from '@forwardflow/types'

export default class AnalyticsService {
   static getFubLostOpportunities = async () => {
      const data = await apiGet<ResponseSuccess<IFubLostOpportunities>>({
         apiPath: `/marketing/analytics/fub/lost-opportunities`,
      })
      return data.data
   }
   static getAvgTimeTakenForFirstCall = async () => {
      const data = await apiGet<ResponseSuccess<ITimeTakenForFirstCall>>({
         apiPath: `/marketing/analytics/fub/avg-time-taken-for-first-call`,
      })
      return data.data
   }

   static getStagesInformation = async () => {
      const data = await apiGet<ResponseSuccess<IStageData>>({
         apiPath: `/marketing/analytics/fub/stages-information`,
      })
      return data.data.stagesInformation
   }

   static getIncompleteInformation = async () => {
      const data = await apiGet<ResponseSuccess<IIncompleteInformation>>({
         apiPath: `/marketing/analytics/fub/incomplete-information`,
      })
      return data.data
   }

   static getOnboardingStats = async () => {
      const data = await apiGet<ResponseSuccess<IAnalyticsStats>>({
         apiPath: `/analytics/onboarding/stats`,
      })
      return data.data
   }

   static getAnalyticsData = async () => {
      const data = await apiGet<ResponseSuccess<any>>({
         apiPath: `/marketing-analytics`,
      })
      return data.data
   }
}
